import { useRef, useState, useEffect } from 'react';

const defaultDOMRect = {
  height: 0,
  width: 0,
  x: 0,
  y: 0,
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  toJSON: () => {
  }
};
const useDimensions = () => {
  const ref = useRef(null);
  const [dimensions, setDimensions] = useState(defaultDOMRect);
  useEffect(() => {
    const rect = ref && ref.current ? ref.current.getBoundingClientRect() : defaultDOMRect;
    setDimensions(rect);
  }, []);
  return [ref, dimensions];
};

export { useDimensions };
//# sourceMappingURL=useDimensions.es.js.map
